import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    labelCopy: string;
    labelDelete: string;
    labelDisableAccess: string;
    labelDuplicate: string;
    labelEditShare: string;
    labelEnableAccess: string;
    labelHeader: (count: number) => string | React.ReactNode;
    labelRename: string;
    labelOpenInNewTab: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** a label for the menu item that copies a link to the clipboard */
            labelCopy: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ShareActionsMenu.labelCopy?c=10sswn5pln6b", defaultMessage: "Copy Link" }));
                },
                enumerable: true,
                configurable: true
            },
            /** a label for the menu item that deletes a share */
            labelDelete: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ShareActionsMenu.labelDelete?c=7nzkz7owpk0x", defaultMessage: "Delete" }));
                },
                enumerable: true,
                configurable: true
            },
            /** a label for the menu item that disables access to a share */
            labelDisableAccess: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ShareActionsMenu.labelDisableAccess?c=3mn8lho38wayu", defaultMessage: "Disable Access" }));
                },
                enumerable: true,
                configurable: true
            },
            /** a label for the menu item that duplicates a share */
            labelDuplicate: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ShareActionsMenu.labelDuplicate?c=gwcnintdwpnx", defaultMessage: "Duplicate" }));
                },
                enumerable: true,
                configurable: true
            },
            /** a label for the menu item that edits a share */
            labelEditShare: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ShareActionsMenu.labelEditShare?c=mg4wexrvdogl", defaultMessage: "Edit Share" }));
                },
                enumerable: true,
                configurable: true
            },
            /** a label for the menu item that enables access to a share */
            labelEnableAccess: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ShareActionsMenu.labelEnableAccess?c=2qwy0hipi3531", defaultMessage: "Enable Access" }));
                },
                enumerable: true,
                configurable: true
            },
            /** a label for the header of a pop-up menu */
            labelHeader: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number) => __intl__.intl().formatMessage({ id: "ShareActionsMenu.labelHeader?c=2iq02lc1s817a", defaultMessage: "{count, number} Shares" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            },
            /** a label for the menu item that renames a share */
            labelRename: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ShareActionsMenu.labelRename?c=2xvuf86b5nq1g", defaultMessage: "Rename" }));
                },
                enumerable: true,
                configurable: true
            },
            /** a label for the menu item that opens a share page */
            labelOpenInNewTab: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ShareActionsMenu.labelOpenInNewTab?c=aytfxzztv61o", defaultMessage: "Open Share" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
